/**
 * Tracks that have more than 4 bars of notes have a little
 * helper at the top that shows a highlevel view of the piano
 * roll. You can click sections which will make the step sequencer
 * show those steps
 *
 */

import React, { memo, Component } from 'react';
import Steps from './Steps.js';
import { connect } from "react-redux";
import PlayTick from './PlayTick.js';

const PART_LENGTH = 128;

function StepsMap(props) {
    let length = props.track.pattern.length(props.resolution);
    let arr = Array(length).fill(0);

    const getStepClassName = (i) => {
        return props.steps[i] ? 'on' : 'off';
    };

    let steps = (props.trackStepIds || [])
        .map((s, i) => ({
            step: s,
            stepNumber: i
        }))
        .filter(s => s.step && s.step.on);

    let numberParts = Math.ceil(props.track.length / PART_LENGTH);
    let parts = Array(numberParts).fill(0);

    return (
        <div className="steps-map">
          {parts.map(
              (x, i) =>
                  <Part
                        i={i}
                        track={props.track}
                        sequencerEngine={props.sequencerEngine}
                        partNumber={props.partNumber}
                    />)}
          <Steps
            resolution={props.resolution}
            steps={steps}
            pattern={props.track.pattern}
            trackColor={props.trackColor}
            length={length} />
         <PlayTick
            track={props.track}
            sequencerEngine={props.sequencerEngine}/>
        </div>
    );
}

function Part(props) {
    let className = 'part';
    if (props.i === props.partNumber) {
        className += ' current-part';
    }

    const onClickPart = () => {
        props.sequencerEngine.cursor.step = props.i * PART_LENGTH;
        let trackStep = props.sequencerEngine.trackStep;
        props.sequencerEngine.seekToTrackStep(
            (trackStep % PART_LENGTH) + props.i * PART_LENGTH,
            false);
    };

    return (
        <div
          onClick={() => onClickPart()}
          className={className}/>
    );
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.getSequenceId();
    let steps = state.tracks.trackSteps[props.track.id];

    return {
        resolution: state.sequencer.displayResolution,
        steps: steps,
        trackStepIds: state.tracks.trackStepIds[props.track.id],
    };
};

export default connect(mapStateToProps, null)(StepsMap);
